export const airbrakeAFMS92DaysSchema = {
  heights: { header1: "60px" },
  classes: { header2: "" },
  inlineData: true,
  columns: [
    {
      title: "Temperature For Calibration (F)",
      colSpan: 1,
      rowSpan: 1,
      className: "tbl-text-normal",
      accessor: "tempForCalibration",
    },
    {
      title: "Recorded CFM",
      colSpan: 1,
      rowSpan: 1,
      className: "tbl-text-normal",
      accessor: "cfmRecorded",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/AirBrakeReports/AirBrakeReports/AirBrakeAFM92Schema.jsx